import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import ProtectedRoute from './components/ProtectedRoute';
import SuperAdminRoute from './components/SuperAdminRoute';
import CustomerAdminRoute from './components/CustomerAdminRoute';
import DomainRedirect from './components/DomainRedirect';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SuperAdminPortal from './pages/SuperAdminPortal';
import CustomerAdminPortal from './pages/CustomerAdminPortal';
import VotingPortal from './pages/VotingPortal';
import AuthVerifyPage from './pages/AuthVerifyPage';
import DebugAuthPage from './pages/DebugAuthPage';
import AcceptInvitation from './pages/AcceptInvitation';
import NotFoundPage from './pages/NotFoundPage';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import SitemapPage from './pages/SitemapPage';
import RssPage from './pages/RssPage';

function App() {
  return (
    <>
      <Toaster position="top-right" richColors />
      <DomainRedirect />
      <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/sitemap.xml" element={<SitemapPage />} />
      <Route path="/rss.xml" element={<RssPage />} />
      <Route path="/auth/verify" element={<AuthVerifyPage />} />
      <Route path="/debug/auth" element={<DebugAuthPage />} />
      <Route path="/accept-invitation" element={<AcceptInvitation />} />

      {/* Protected routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />

      {/* Super admin route */}
      <Route
        path="/admin"
        element={
          <SuperAdminRoute>
            <SuperAdminPortal />
          </SuperAdminRoute>
        }
      />

      {/* Voting portal - public customer portal */}
      <Route path="/:slug" element={<VotingPortal />} />

      {/* Customer admin route - must come after voting portal to not conflict */}
      <Route
        path="/:slug/admin"
        element={
          <CustomerAdminRoute>
            <CustomerAdminPortal />
          </CustomerAdminRoute>
        }
      />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </>
  );
}

export default App;
